import { render, staticRenderFns } from "./transactionGoods.vue?vue&type=template&id=207fd93c"
import script from "./transactionGoods.vue?vue&type=script&lang=js"
export * from "./transactionGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports